import apiClient from '../apiClient';
import type { BaseResponse } from '../../types/base.dto';
import type { OrderPreRatingDetail } from '../../types/process/order-pre-rating';

/**
 * 获取指定订单的预评级结果
 * 若后端尚无评级记录，后端会降级触发即时计算并返回结果
 */
async function getPreRating(orderNo: string): Promise<BaseResponse<OrderPreRatingDetail>> {
  const response = await apiClient.get<BaseResponse<OrderPreRatingDetail>>(
    `/orders/${orderNo}/pre-rating`
  );
  return response.data;
}

export const orderPreRatingApi = { getPreRating };
